import { delay, mergeMap } from 'rxjs';
import { Observable, of } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';

import { Actions, AppMsg } from '../app.actions';

/**
 * Handle hiding alerts to the user
 * @param action$
 */
export function alertEpic(action$: Observable<any>): Observable<any> {
    return action$.pipe(
        ofType<Actions>('App.DismissAlert'),
        mergeMap(() => {
            return of(AppMsg('App.ClearAlert')).pipe(delay(300));
        }),
    );
}
